//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, DateSelectionType } from '@constants'
import { isEmpty } from 'lodash'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import CloseThickIcon from 'vue-material-design-icons/CloseThick.vue'
import CalendarIcon from 'vue-material-design-icons/Calendar.vue'
import ArrowLeftCircle from 'vue-material-design-icons/ArrowLeftCircle.vue'
import ArrowRightCircle from 'vue-material-design-icons/ArrowRightCircle.vue'

const FIND_ARTICLES = gql`
  query ($where: ArticleSearchWhereInput) {
    searchArticles(where: $where) {
      id
      externalId
      date
      title
      slug
      redirectUrl
      abstract
      edition {
        id
        name
      }
      country {
        id
        name
      }
      region {
        id
        name
      }
      contentType {
        id
        name
        colour
        contentTypeGroup {
          id
          name
        }
      }
    }
  }
`

const DATA_QUERY = gql`
  query {
    contentTypeGroups(first: 999) {
      nodes {
        id
        name
      }
    }
    tags(order: [{ name: ASC }], first: 999) {
      nodes {
        id
        name
        text
      }
    }
    editions(where: { isActive: { eq: true } }, first: 999) {
      nodes {
        id
        name
      }
    }
    countries(order: [{ name: ASC }], first: 999) {
      nodes {
        id
        name
      }
    }
  }
`

const CREATE_USER_ARTICLE = gql`
  mutation ($data: UserArticleInput) {
    upsertUserArticle(data: $data) {
      article {
        id
      }
    }
  }
`

const DELETE_USER_ARTICLE = gql`
  mutation ($data: UserArticleInput) {
    deleteUserArticle(data: $data) {
      article {
        id
      }
    }
  }
`

export default {
  name: 'SearchPage',
  components: { DatePicker, CloseThickIcon, CalendarIcon, ArrowLeftCircle, ArrowRightCircle },
  fetchOnServer: false,
  beforeRouteLeave(to, from, next) {
    this.$store.set('search/yPos', window.scrollY)
    next()
  },
  data() {
    return {
      showPlaceholder: false,
      placeholders: 5,
      DateSelectionType,
      articles: [],
      types: [],
      editions: [],
      countries: [],
      tags: [],
      searched: false,
      text: null,
      pagination: {
        total: 0,
        pageSize: 25,
        page: 1
      },
      lastSearch: {
        id: null,
        date: null
      },
      filters: {
        order: 'date:desc',
        text: null,
        types: [],
        queryBy: {
          TITLE: true,
          FULL_TEXT: true,
          COMPANY: true
        },
        editions: [],
        country: null,
        tags: [],
        dateChoice: null,
        dateStart: null,
        dateEnd: null
      },
      resultOrder: []
    }
  },
  async fetch() {
    await this.refresh()
  },
  computed: {
    query() {
      return this.$route.params.q || this.$route.query.q
    },
    querytag() {
      return this.$route.params.t || this.$route.query.t
    },
    queryFilters() {
      return isEmpty(this.$route.query.f) ? null : JSON.parse(window.atob(decodeURIComponent(this.$route.query.f)))
    },
    queryPagination() {
      return isEmpty(this.$route.query.p) ? null : JSON.parse(window.atob(decodeURIComponent(this.$route.query.p)))
    },
    queryLastSearch() {
      return isEmpty(this.$route.query.l) ? null : JSON.parse(window.atob(decodeURIComponent(this.$route.query.l)))
    },
    queryText() {
      return this.$route.query.q
    },
    queryTag() {
      return this.$route.query.t
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    isFiltered() {
      return !isEmpty(this.filters)
        ? this.filters.types.length > 0 ||
            this.filters.editions.length > 0 ||
            this.filters.country != null ||
            this.filters.tags.length > 0 ||
            this.filters.dateChoice != null
        : false
    },
    dateChoices() {
      return [
        { name: this.$t('search.date_choices.past_year'), value: DateSelectionType.PAST_YEAR },
        // { name: this.$t('search.date_choices.all'), value: DateSelectionType.ALL },
        { name: this.$t('search.date_choices.today'), value: DateSelectionType.TODAY },
        { name: this.$t('search.date_choices.week'), value: DateSelectionType.WEEK },
        { name: this.$t('search.date_choices.month'), value: DateSelectionType.MONTH },
        { name: this.$t('search.date_choices.year'), value: DateSelectionType.YEAR },
        { name: this.$t('search.date_choices.range'), value: DateSelectionType.RANGE }
      ]
    },
    sortOrders() {
      return [
        { value: 'date:desc', label: this.$t('search.filters.sort_desc') },
        { value: 'date:asc', label: this.$t('search.filters.sort_asc') }
      ]
    },
    searchTypes() {
      return [
        {
          name: this.$t('search.filters.title'),
          value: 'TITLE'
        },
        {
          name: this.$t('search.filters.full_text'),
          value: 'FULL_TEXT'
        },
        {
          name: this.$t('search.filters.company'),
          value: 'COMPANY'
        }
      ]
    },
    pageOptions() {
      return [
        { value: 25, label: this.$t('search.page_options.25') },
        { value: 50, label: this.$t('search.page_options.50') },
        { value: 100, label: this.$t('search.page_options.100') }
      ]
    },
    hasNextPage() {
      return this.pagination.page * this.pagination.pageSize < this.pagination.total
    },
    hasPreviousPage() {
      return this.pagination.page > 1
    },
    bookmarkArticleIds() {
      return this.$store.get('bookmark/articleIds') || []
    },
    account() {
      return this.$store.get('user/user') || null
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('search-results-found')
    this.$nuxt.$off('search-results-order')
    this.$nuxt.$off('search-changed-globally')
    this.$nuxt.$off('language-change')
  },
  mounted() {
    if (this.queryText != null || this.queryTag != null) {
      if (this.queryText != null) {
        this.filters.text = this.queryText
      }

      if (this.queryTag != null) {
        this.filters.tags = this.filters.tags.concat(this.queryTag.split(','))
      }
    } else if (isEmpty(this.queryFilters)) {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters))
      this.$store.set('search/articles', [])
      this.$store.set('search/total', 0)
      this.$store.set('search/yPos', 0)
    } else {
      this.filters = JSON.parse(JSON.stringify(this.queryFilters))
      this.filters.dateStart = new Date(this.filters.dateStart)
      this.filters.dateEnd = new Date(this.filters.dateEnd)

      if (this.$store.get('search/text') !== this.filters?.text) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })

        this.$store.set('search/articles', [])
        this.$store.set('search/total', 0)
        this.$store.set('search/yPos', 0)
      } else if (this.$store.get('search/articles')?.length > 0) {
        this.articles = this.$store.get('search/articles')
        this.pagination.total = this.$store.get('search/total')
      }

      this.searched = true
      this.text = this.filters.text

      if (this.$store.get('search/yPos') > 0) {
        const position = this.$store.get('search/yPos')

        // without the timeout the scroll to will fail
        setTimeout(function () {
          window.scrollTo(0, position)
        }, 10)
      }
    }

    if (!isEmpty(this.queryPagination)) {
      this.pagination = JSON.parse(JSON.stringify(this.queryPagination))
    }

    if (!isEmpty(this.queryLastSearch)) {
      this.lastSearch = JSON.parse(JSON.stringify(this.queryLastSearch))
    }

    this.$nuxt.$on('search-results-found', (val) => {
      this.pagination.total = parseInt(val)
      this.$store.set('search/total', parseInt(val))
    })

    this.$nuxt.$on('search-changed-globally', async (text) => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      this.filters.text = text
      await this.onSearchOptionChange()
    })

    this.$nuxt.$on('search-results-order', (val) => {
      this.resultOrder = val.split(',').map(Number)
    })

    this.$nuxt.$on('language-change', async () => {
      this.lastSearch.id = null
      this.lastSearch.date = null
      this.articles = []
      await this.refresh(true)
    })

    this.setBreadcrumb({
      isShow: true,
      pageTitle: this.$t('search.heading')
    })
  },
  methods: {
    async refresh(purge = false) {
      try {
        this.showPlaceholder = true
        const { data } = await this.$apollo.query({
          query: DATA_QUERY,
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        if (data) {
          this.types = data.contentTypeGroups.nodes
          this.editions = data.editions.nodes
          this.countries = data.countries.nodes
          this.tags = data.tags.nodes
        }

        if (
          typeof window !== 'undefined' &&
          (this.filters.text || (this.filters.tags && this.filters.tags.length > 0)) &&
          this.articles.length === 0
        ) {
          await this.findArticles(false)
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    },
    async findArticles(search = true, direction = 'BACKWARD') {
      this.showPlaceholder = true

      // if there is no queryBy options set we cannot proceed
      if (Object.values(this.filters.queryBy).filter((x) => x === true).length === 0) {
        this.articles = []
        this.showPlaceholder = false
        this.pagination.total = 0
        return
      }

      let startAt = null
      let endAt = null
      if (this.filters.dateChoice !== null) {
        ;({ startAt, endAt } = this.getDateFilter())
      }

      switch (direction) {
        case 'BACKWARD': {
          // set the values of the last article found to use in subsequent queries using next or previous page
          const last = this.articles[this.articles.length - 1]
          if (last) {
            this.lastSearch.id = last.id
            this.lastSearch.date = last.date
          }

          break
        }

        case 'FORWARD':
        default: {
          const last = this.articles[0]
          if (last) {
            this.lastSearch.id = last.id
            this.lastSearch.date = last.date
          }

          break
        }
      }

      if (!isEmpty(this.filters) && search) {
        window.history.replaceState(
          {},
          document.title,
          `/search?f=${encodeURIComponent(window.btoa(JSON.stringify(this.filters)))}&p=${encodeURIComponent(
            window.btoa(JSON.stringify(this.pagination))
          )}&l=${encodeURIComponent(window.btoa(JSON.stringify(this.lastSearch)))}`
        )
      }

      try {
        const { data } = await this.$apollo.query({
          query: FIND_ARTICLES,
          variables: {
            where: {
              useTypesense: false,
              text: this.filters.text,
              contentTypeGroupIds: this.filters.types,
              editionIds: this.filters.editions,
              countryId: this.filters.country,
              tags: this.filters.tags,
              perPage: this.pagination.pageSize,
              page: this.pagination.page,
              sortBy: this.filters.order,
              languageId: this.languageId,
              queryBy: Object.keys(this.filters.queryBy).filter((key) => this.filters.queryBy[key]),
              articleId: this.lastSearch.id,
              date: this.lastSearch.date,
              direction,
              startAt,
              endAt
            }
          },
          fetchPolicy: 'network-only'
        })

        this.searched = true
        this.text = this.filters.text
        this.articles = data.searchArticles

        // store the last searched articles in the store so if the user comes back with the same filters we can pre-populate with these
        this.$store.set('search/articles', this.articles)
        this.$store.set('search/text', this.filters.text)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    },
    getDateFilter() {
      let startAt = null
      let endAt = null

      switch (this.filters.dateChoice) {
        case DateSelectionType.ALL:
          startAt = this.$dayjs('1993-01-01').startOf('year')
          endAt = this.$dayjs().endOf('year')
          break
        case DateSelectionType.WEEK:
          startAt = this.$dayjs(this.filters.dateStart).startOf('week')
          endAt = this.$dayjs(this.filters.dateStart).endOf('week')
          break
        case DateSelectionType.MONTH:
          startAt = this.$dayjs(this.filters.dateStart).startOf('month')
          endAt = this.$dayjs(this.filters.dateStart).endOf('month')
          break
        case DateSelectionType.YEAR:
          startAt = this.$dayjs(this.filters.dateStart).startOf('year')
          endAt = this.$dayjs(this.filters.dateStart).endOf('year')
          break
        case DateSelectionType.RANGE:
          startAt = this.$dayjs(this.filters.dateStart).startOf('day')
          endAt = this.$dayjs(this.filters.dateEnd).endOf('day')
          break
        case DateSelectionType.PAST_YEAR:
        default:
          startAt = this.$dayjs().subtract(1, 'year')
          endAt = this.$dayjs().endOf('day')
          break
      }
      return {
        startAt,
        endAt
      }
    },
    async onDateSelectionChange() {
      this.filters.dateStart = new Date()
      this.filters.dateEnd = new Date()

      await this.onSearchOptionChange()
    },
    async onPaginationChange(direction) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })

      await this.findArticles(true, direction)
    },
    async onFiltersClear() {
      this.searched = false
      this.filters.types = []
      this.filters.editions = []
      this.filters.country = null
      this.filters.tags = []
      this.filters.dateChoice = DateSelectionType.PAST_YEAR
      await this.onSearchOptionChange()
    },
    onChangeStartDate() {
      if (this.filters.dateEnd !== null && this.filters.dateStart > this.filters.dateEnd) {
        this.filters.dateEnd = this.filters.dateStart
      }

      if (this.filters.dateStart !== null && this.filters.dateEnd !== null) {
        this.onSearchOptionChange()
      }
    },
    onChangeEndDate() {
      if (this.filters.dateStart !== null && this.filters.dateEnd !== null) {
        this.onSearchOptionChange()
      }
    },
    async onSearchOptionChange() {
      // reset all the values back to their default state
      this.pagination.page = 1
      this.showPlaceholder = true

      this.lastSearch.id = null
      this.lastSearch.date = null
      this.articles = []
      await this.findArticles()
    },
    async onNextPageClick() {
      if (this.hasNextPage === false) return

      this.pagination.page += 1
      await this.onPaginationChange('BACKWARD')
    },
    async onPreviousPageClick() {
      if (this.hasPreviousPage === false) return

      this.pagination.page -= 1
      await this.onPaginationChange('FORWARD')
    },
    async onBookmarkAll(isBookmarked) {
      try {
        let articleIds = this.bookmarkArticleIds
        const promises = []

        this.articles.forEach((x) => {
          promises.push(
            this.$apollo.mutate({
              mutation: isBookmarked ? CREATE_USER_ARTICLE : DELETE_USER_ARTICLE,
              variables: { data: { articleId: x.id } }
            })
          )

          if (!isBookmarked) {
            articleIds = articleIds.filter((y) => y !== x.id)
          } else if (!articleIds.includes(x.id)) articleIds.push(x.id)
        })

        await Promise.all(promises)

        this.$store.set('bookmark/articleIds', articleIds)
      } catch (error) {
        console.error(error)
        this.$buefy.notification.open({
          duration: 5000,
          message: this.$t('article_binder.error_not_binded'),
          type: 'is-danger'
        })
      }
    }
  }
}
